import { render, staticRenderFns } from "./TheBusinessItemContact.vue?vue&type=template&id=9d4eec6c"
import script from "./TheBusinessItemContact.vue?vue&type=script&lang=js"
export * from "./TheBusinessItemContact.vue?vue&type=script&lang=js"
import style0 from "./TheBusinessItemContact.vue?vue&type=style&index=0&id=9d4eec6c&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports